"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));

var _isObject = _interopRequireDefault(require("lodash/isObject"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var FeFilter =
/*#__PURE__*/
function () {
  function FeFilter() {
    _classCallCheck(this, FeFilter);
  }

  _createClass(FeFilter, [{
    key: "filter",
    value: function filter(subStr, collection, config) {
      var _subStr = this.getSubString(subStr, config.matchExact);

      var _regx;

      try {
        if (config.matchExact) {
          _regx = _subStr;
        } else {
          _regx = new RegExp(_subStr, 'gi');
        }
      } catch (err) {
        return [];
      }

      var _collection = (0, _cloneDeep.default)(collection);

      var _filteredList = this.apply(_regx, _collection, config);

      return _filteredList;
    }
  }, {
    key: "getSubString",
    value: function getSubString(subStr, matchExact) {
      var _length = subStr.length,
          _subStr = subStr;

      if (_length === 2 && _subStr[_length - 1] === '*') {
        _subStr = _subStr.substring(0, 1);
      } else if (_subStr[_length - 1] === '*') {
        _subStr = _subStr.substring(0, _length - 1).replace(/\*/g, '.') + '*';
      } else {
        _subStr = _subStr.replace(/\*/g, '.');
      }

      return _subStr;
    }
  }, {
    key: "apply",
    value: function apply(regx, collection, config) {
      var _this = this;

      var _list = [];
      collection.forEach(function (o) {
        var _listItem;

        _listItem = _this.match(regx, o, config);

        if (_listItem) {
          _list.push(_listItem);
        }
      });
      return _list;
    }
  }, {
    key: "match",
    value: function match(regx, o, config) {
      var _this2 = this;

      var _matched = null;

      if ((0, _isObject.default)(o)) {
        if (config.queryAt) {
          if (config.matchExact) {
            _matched = o[config.queryAt] && o[config.queryAt] === regx;
          } else {
            _matched = o[config.queryAt] && o[config.queryAt].search(regx) > -1;
          }
        } else if (config.isDeepSearch) {
          o.forEach(function (key, value) {
            var i = _this2.match(regx, value, config);

            _matched = _matched ? true : i !== null;
          });
        } else {
          _matched = null;
        }
      } else if (Array.isArray(o)) {
        return this.apply(regx, o, config);
      } else {
        if (config.matchExact) {
          _matched = o && o === regx;
        } else {
          _matched = o.search(regx) > -1;
        }
      }

      if (_matched) {
        return o;
      } else if (!_matched && config.isMultiLevel && config.multiLevelKey && o[config.multiLevelKey]) {
        var _matchedList = [];
        _matchedList = this.apply(regx, o[config.multiLevelKey], config);

        if (_matchedList.length) {
          o[config.multiLevelKey] = _matchedList;
          return o;
        }
      }

      return null;
    }
  }]);

  return FeFilter;
}();

var _default = new FeFilter();

exports.default = _default;